import axios from "axios";
import { API } from "@/lib/api";

export const portalApi = (token) => {
  const base = `${API}/portal/${token}`;
  const http = axios.create({ baseURL: base });
  const descargar = async (ruta, nombre) => {
    const { data } = await http.get(ruta, { responseType: "blob" });
    const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(data), download: nombre });
    document.body.appendChild(a); a.click(); a.remove();
  };
  return { http, descargar, fotoUrl: (id) => `${base}/fotos/${id}` };
};

export const ESTADO_PASOS = [["pendiente", "Pendiente"], ["en_curso", "En curso"], ["finalizado", "Finalizada"]];

export const METODOS = { transferencia: "Transferencia", efectivo: "Efectivo", tarjeta: "Tarjeta", bizum: "Bizum", domiciliacion: "Domiciliación" };
